{
  "fr": {
    "empty": {
      "headlines": {
        "default": "Il n'y a rien à voir ici...",
        "forName": "Aucun %{name} trouvé",
        "hangar": "Votre hangar est vide",
        "wishlist": "Votre liste de souhaits est vide",
        "features": "Aucune fonctionnalité disponible",
        "fleetFeatures": "Aucune fonctionnalité de flotte disponible",
        "imports": "Aucun import trouvé",
        "transfers": "Aucun transfert pour l'instant"
      },
      "actions": {
        "reset": "Réinitialiser les filtres/pages",
        "resetPage": "Aller à la première page"
      },
      "texts": {
        "info": "Nous n'avons trouvé aucun enregistrement.",
        "query": "It seems like you have some Filters active or visited a Page without any Records."
      },
      "info": {
        "hangar": "You can add Ships to your Hangar by clicking on the bookmark icon in the top right corner of a Ship or by using the Plus Button in the bottom right corner.",
        "extension": "Additionally you can import your Hangar from the RSI Website via the Fleetyards Sync Browser extension.",
        "wishlist": "You can add Ships to your Wishlist by clicking on the bookmark icon in the top right corner of a Ship.",
        "features": "Il n'y a actuellement aucune fonctionnalité libre-service disponible. Revenez plus tard car de nouvelles fonctionnalités sont ajoutées régulièrement.",
        "fleetFeatures": "Il n'y a actuellement aucune fonctionnalité qu'une flotte peut activer elle-même. Revenez plus tard car de nouvelles fonctionnalités sont ajoutées régulièrement."
      },
      "payouts": {
        "archivedTours": "Aucune expédition archivée",
        "entries": "Rien d'enregistré pour l'instant",
        "participants": "Personne sur cette expédition",
        "transfers": "Clôturez pour voir qui paie qui",
        "tours": "Aucune expédition"
      },
      "fleets": {
        "contracts": {
          "items": "Aucune marchandise. Ajoutez ce que ce contrat demande — il ne peut pas être publié vide."
        },
        "events": {
          "upcoming": "Rien de prévu",
          "past": "Rien ne s'est encore passé",
          "archived": "Rien d'archivé",
          "info": {
            "upcoming": "Créez un événement pour rassembler la flotte — choisissez une date, ajoutez des postes et laissez les membres s'inscrire.",
            "past": "Un événement arrive ici une fois son heure de fin passée.",
            "archived": "Archiver retire un événement de la liste sans le supprimer."
          }
        },
        "missions": {
          "active": "Aucune mission",
          "archived": "Rien d'archivé",
          "info": {
            "active": "Une mission est un plan réutilisable — équipes, vaisseaux et postes — à partir duquel vous créez des événements.",
            "archived": "Archiver retire une mission de la liste sans la supprimer."
          }
        },
        "squadrons": {
          "headline": "Aucun escadron",
          "info": "Les escadrons répartissent la flotte en groupes, chacun avec ses membres, son emblème et ses couleurs. Les équipes s'y ajoutent pour les membres qui appartiennent à plusieurs groupes."
        }
      }
    }
  }
}
